// Source: https://github.com/vinted/dwh-schema-registry/blob/5387d2ce7b44ee93711a15dfb97c60a4d984f22c/avro/events/common/shared/user.avdl#L25
type UserTarget = 'edit_item' | 'delete_item' | 'hide_item'

type ClickEventArgs = {
  target: UserTarget
  screen?: string | null
  targetDetails?: string | null
  path?: string | null
  env?: string | null
}

type ClickEventExtra = {
  target: UserTarget
  screen?: string
  target_details?: string
  path?: string | null
  env?: string | null
}

export const clickEvent = (args: ClickEventArgs) => {
  const { target, screen, targetDetails, env, path } = args
  const extra: ClickEventExtra = { target }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  if (env) extra.env = env

  if (path) extra.path = path

  return {
    event: 'user.click',
    extra,
  }
}

type ItemAttributesEventArgs = {
  itemId: string
  attributeCode: string
  attributeValueId?: string
  details?: string
  itemPageSessionId?: string
}

type ItemAttributesEventExtra = {
  screen: string
  item_id: string
  attribute_code: string
  attribute_value_id?: string | null
  details?: string | null
  item_page_session_id?: string | null
}

export const itemAttributesClickEvent = (args: ItemAttributesEventArgs) => {
  const { itemId, attributeCode, attributeValueId, details, itemPageSessionId } = args

  const extra: ItemAttributesEventExtra = {
    screen: 'item',
    item_id: itemId,
    attribute_code: attributeCode,
  }

  if (attributeValueId) extra.attribute_value_id = attributeValueId
  if (details) extra.details = details
  if (itemPageSessionId) extra.item_page_session_id = itemPageSessionId

  return {
    event: 'item_page.item_attributes.click',
    extra,
  }
}
